import { Box, Typography } from '@mui/material';
import { colors } from '../styles/theme.js';

interface Props {
  score: number;
  label?: string;
  size?: number;
}

function getScoreColor(score: number): string {
  if (score >= 80) return colors.scoreGreen;
  if (score >= 50) return colors.scoreYellow;
  return colors.scoreRed;
}

export default function ScoreGauge({ score, label, size = 140 }: Props) {
  const color = getScoreColor(score);
  const radius = (size - 12) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (score / 100) * circumference;
  const center = size / 2;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
      <Box sx={{ position: 'relative', width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* Background circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="8"
          />
          {/* Progress arc */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={`${progress} ${circumference}`}
            transform={`rotate(-90 ${center} ${center})`}
            style={{ transition: 'stroke-dasharray 0.8s ease' }}
          />
        </svg>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600, color }}>
            {Math.round(score)}
          </Typography>
        </Box>
      </Box>
      {label && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', fontWeight: 400 }}>
          {label}
        </Typography>
      )}
    </Box>
  );
}
